import type { FunctionComponent } from 'react';
import { lazy as lazyLoad } from 'react';

import { DashboardAccessGuard } from '../../dashboard-visibility/DashboardAccessGuard';
import type { RouteDefinition } from '../../route';
import { route } from './constants';

const lazy = {
    DashboardPage: lazyLoad(async () => {
        const { DashboardPage } = await import('./Dashboard');

        const GuardedDashboardPage: FunctionComponent = () => (
            <DashboardAccessGuard dashboard="talent">
                <DashboardPage />
            </DashboardAccessGuard>
        );

        return { default: GuardedDashboardPage };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'navigation.dashboard',
        page: lazy.DashboardPage,
        path: route.patterns.dashboard,
    },
];
